import React, { useEffect, useMemo, useState } from "react";
import {
  Col, Row, Card, CardBody, Button, Spinner, Alert
} from "reactstrap";
import TableContainer from "../../../components/Common/TableContainer";
import Breadcrumbs from "../../../components/Common/Breadcrumb";

const BASE_URL = "https://harmanappapi.stechomeyazilim.info";

const getAuthHeaders = () => {
  const authUser = JSON.parse(localStorage.getItem("authUser") || "{}");
  const token = localStorage.getItem("token") || authUser?.Token;
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
};

const KullaniciBankaBilgileri = () => {
  document.title = "Kullanıcı Banka Bilgileri | HarmanaGEL";

  const [bankalar, setBankalar] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchBankalar = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await fetch(
        `${BASE_URL}/KULLANICI_BANKA_BILGILERI?$top=500&$orderby=OLUSTURMA_TARIHI desc&$expand=KULLANICILAR($select=AD_SOYAD,Mail_Adress,CEP_NO)`,
        { headers: getAuthHeaders() }
      );
      const result = await response.json();
      if (result && result.value) setBankalar(result.value);
    } catch (err) {
      setError("Banka bilgileri yüklenirken hata oluştu.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchBankalar();
  }, []);

  const columns = useMemo(() => [
    {
      header: "ID",
      accessorKey: "ID",
      enableSorting: true,
      enableColumnFilter: false,
      cell: (cell) => <span className="fw-bold">#{cell.getValue()}</span>,
    },
    {
      header: "Kullanıcı",
      accessorKey: "KULLANICILAR",
      enableSorting: false,
      enableColumnFilter: true,
      cell: (cell) => {
        const u = cell.getValue();
        return u ? (
          <div>
            <div className="fw-medium">{u.AD_SOYAD}</div>
            <small className="text-muted">{u.Mail_Adress}</small>
          </div>
        ) : <span className="text-muted">Kullanıcı #{cell.row.original.KULLANICI_ID}</span>;
      },
    },
    {
      header: "Banka Adı",
      accessorKey: "BANKA_ADI",
      enableSorting: true,
      enableColumnFilter: true,
      cell: (cell) => <span className="fw-medium">{cell.getValue() || "-"}</span>,
    },
    {
      header: "Hesap Sahibi",
      accessorKey: "HESAP_SAHIBI",
      enableSorting: true,
      enableColumnFilter: true,
      cell: (cell) => <span>{cell.getValue() || "-"}</span>,
    },
    {
      header: "Şube",
      accessorKey: "SUBE_ADI",
      enableSorting: true,
      enableColumnFilter: true,
      cell: (cell) => <span>{cell.getValue() || "-"}</span>,
    },
    {
      header: "IBAN",
      accessorKey: "IBAN",
      enableSorting: false,
      enableColumnFilter: false,
      cell: (cell) => <span className="font-monospace small">{cell.getValue() || "-"}</span>,
    },
    {
      header: "Kayıt Tarihi",
      accessorKey: "OLUSTURMA_TARIHI",
      enableSorting: true,
      enableColumnFilter: false,
      cell: (cell) => {
        const d = cell.getValue();
        return d ? new Date(d).toLocaleDateString("tr-TR") : "-";
      },
    },
  ], []);

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="HarmanaGEL" breadcrumbItem="Kullanıcı Banka Bilgileri" />

          {error && <Alert color="danger" toggle={() => setError(null)}>{error}</Alert>}

          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4 className="card-title mb-0">Banka Bilgileri</h4>
                    <Button color="primary" size="sm" onClick={fetchBankalar} disabled={isLoading}>
                      <i className="bx bx-refresh me-1" />
                      Yenile
                    </Button>
                  </div>

                  {isLoading ? (
                    <div className="text-center py-5"><Spinner color="primary" /></div>
                  ) : (
                    <TableContainer
                      columns={columns}
                      data={bankalar}
                      isGlobalFilter={true}
                      SearchPlaceholder="Banka ara..."
                      isPagination={true}
                      isCustomPageSize={true}
                      tableClass="table-bordered align-middle nowrap w-100 mb-0"
                      theadClass="table-light"
                      paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                    />
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default KullaniciBankaBilgileri;
